<template>
  <div class="header-container" :class="{'top-header-container-remove-radius' : contentPosition === -250}">
    <div class="top-header-container">
      <BackButton :clickMethod="back" class="mb-3"/>

      <h4>
        {{$tI('Notable Individuals')}}
        <span @click="NotableIndividualsInfoModal.showModal = true" class="open-info-modal-btn">
          <InfoIcon />
        </span>
      </h4>
      <p class="description">
        {{ description }}
      </p>
    </div>

    <NotableInvidualsInfoModal v-if="NotableIndividualsInfoModal.showModal" :modalObject="NotableIndividualsInfoModal"/>
  </div>

</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import NotableInvidualsInfoModal from './modals/NotableInvidualsInfoModal.vue';

export default {
  components: {
    BackButton,
    InfoIcon,
    NotableInvidualsInfoModal,
  },
  props: {
    contentPosition: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      NotableIndividualsInfoModal: {
        showModal: false,
      },

      description: this.$tI_G('Notable Individual Subtitle'),

      underlineStyle: {
        width: '0px',
        left: '0px',
        backgroundColor: '#BB4ECE',
      }
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  background-color: var(--white-100);
  position: sticky;
  top: 0;
  z-index: 10;
  .mobile-header-icon {
    margin-bottom: -28px;
    margin-top: 0;
  }
}

.top-header-container {
  padding: 28px 28px 0 28px;
}

@media screen and (max-width: 769px) {
  .tab {
    font-size: 1rem !important;
  }
  .top-header-container {
    padding: 28px 28px 10px 28px;
  }
}
</style>